import { ValidationInterface } from '../../validation.interface';
import { Product, ProductPropName, ProductType } from '../../../../models/project/plant-specifications/product.model';
import { ProjectValidationUnit } from '../../../../models/data-structures/project-validation';
import { UnitValueValidation } from '../unit-value.validation';

export class ProductValidation implements ValidationInterface {
  /** The current product obj that is being validated */
  private readonly product: Product;

  /**
   * Sets the product obj that will be used for validation
   * @param product will be used to set the current product obj
   */
  constructor(product: Product) {
    if (!product) throw Error('invalid product provided for validation');
    this.product = new Product(product);
  }

  /**
   * Get a validation unit containing the validation data for the current value obj
   */
  getValidation(): ProjectValidationUnit {
    if (!this.product) throw Error('unable to validate product');
    const validationUnit = new ProjectValidationUnit();
       if (this.product.name) {
         validationUnit.setValid(ProductPropName.name);
       } else {
         validationUnit.setInvalid(ProductPropName.name, [ProductError.MissingName]);
       }
       if (this.product.type) {
         validationUnit.setValid(ProductPropName.type);
       } else {
         validationUnit.setInvalid(ProductPropName.type, [ProductError.MissingType]);
       }
       const digestateTypes = [
         ProductType.SolidDigestate,
         ProductType.ThinDigestate,
         ProductType.WholeDigestate,
         ProductType.Electric,
         ProductType.Heat
       ];
       if (digestateTypes.includes(this.product.type)) {
         validationUnit.addModuleResults(
           new UnitValueValidation(this.product.internalDemand).getValidation(),
           ProductPropName.internalDemand
         );
       }
    return validationUnit;
  }

  /**
   * returns a boolean that determines if the current product obj is valid
   */
  isValid(): boolean {
    return this.getValidation().isValid;
  }
}

/**
 * An enum that contains error that relate to product errors
 */
export enum ProductError {
  MissingName = 'VALIDATION.MISSING_NAME',
  MissingType = 'VALIDATION.MISSING_TYPE',
}
